import { observer } from 'mobx-react';
import { useMemo } from 'react';
import ModalReactions from '../../Modal/ModalReactions';
import GroupParticipantsStore from '../Group/GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../Group/GroupParticipantsStore/Types';
import Modal from './Modal';
import AddParticipantReactions from './Store/Reactions';
import AddParticipantStore from './Store';

interface Props {
  groupParticipantsResource: GroupParticipantsResource;
  groupParticipantsStore: GroupParticipantsStore;
}

function AddParticipantModal({ groupParticipantsResource, groupParticipantsStore }: Props) {
  const addParticipantStore = useMemo(
    () => new AddParticipantStore(groupParticipantsResource),
    [groupParticipantsResource],
  );

  return (
    <>
      <Modal
        store={addParticipantStore}
        groupParticipantsResource={groupParticipantsResource}
        groupParticipantsStore={groupParticipantsStore}
      />
      <ModalReactions store={groupParticipantsStore.modalStore} />
      <AddParticipantReactions store={addParticipantStore} />
    </>
  );
}

export default observer(AddParticipantModal);
